import { defineStore } from 'pinia';
import { Country } from '@/enums/Country';
import { ref } from 'vue';
import { THGCarPayoffAmount } from '@/interfaces/thg/THGlobals';
import { getPayoffs } from '@/api/thg/globals';

export const useTHGGlobalStore = defineStore(
    'thgglobal',
    () => {
        const country = ref<Country>(Country.DE);
        const payoffs = ref<THGCarPayoffAmount[]>();

        async function dispatchPayoffs() {
            const response = await getPayoffs();

            if (!response.parsedBody) {
                throw new Error('Cannot retrieve payoffs.');
            }

            payoffs.value = response.parsedBody;
        }

        return {
            currentCountry: country,
            dispatchPayoffs,
            payoffs,
        };
    },
    {
        persist: {
            paths: ['currentCountry'],
        },
    },
);
